import { EmailKeyword } from "../../../services/EmailSerivce";
import {
	EMAIL_KEYWORD_DESCRIPTION_OVERRIDES,
	EMAIL_KEYWORD_GROUP_ORDER,
	EMAIL_KEYWORD_GROUPS,
	EMAIL_KEYWORD_SORT_ORDER,
} from "./emailKeywordConfig";

const resolveGroupLabel = (keywordName: string) => {
	for (const [label, items] of Object.entries(EMAIL_KEYWORD_GROUPS)) {
		if (items.some((item) => item === keywordName)) {
			return label;
		}
	}

	return "Other";
};

const sortGroupItems = (label: string, items: EmailKeyword[]) => {
	return [...items].sort((left, right) => {
		const leftManualOrder = Number.isFinite(Number(left.sortOrder)) ? Number(left.sortOrder) : null;
		const rightManualOrder = Number.isFinite(Number(right.sortOrder)) ? Number(right.sortOrder) : null;

		if (leftManualOrder !== null || rightManualOrder !== null) {
			if (leftManualOrder === null) {
				return 1;
			}
			if (rightManualOrder === null) {
				return -1;
			}
			if (leftManualOrder !== rightManualOrder) {
				return leftManualOrder - rightManualOrder;
			}
		}

		const sortOrder = EMAIL_KEYWORD_SORT_ORDER[label] || {};
		const leftOrder = sortOrder[left.name] ?? Number.MAX_SAFE_INTEGER;
		const rightOrder = sortOrder[right.name] ?? Number.MAX_SAFE_INTEGER;

		if (leftOrder !== rightOrder) {
			return leftOrder - rightOrder;
		}

		return left.name.localeCompare(right.name);
	});
};

export const getKeywordDescription = (item: EmailKeyword) =>
	String(item.descriptionManual || "").trim() ||
	EMAIL_KEYWORD_DESCRIPTION_OVERRIDES[item.name] ||
	item.description ||
	"";

export const filterEmailKeywords = (keywords: EmailKeyword[], searchText = "") => {
	const normalizedSearch = String(searchText || "").trim().toLowerCase();

	return keywords.filter((item) => {
		if (item.enabled === false) {
			return false;
		}

		if (!normalizedSearch) {
			return true;
		}

		return [item.name, item.description]
			.concat(getKeywordDescription(item))
			.filter(Boolean)
			.some((value) => String(value).toLowerCase().includes(normalizedSearch));
	});
};

export const groupEmailKeywords = (keywords: EmailKeyword[]) => {
	const grouped = new Map<string, EmailKeyword[]>();

	keywords.forEach((item) => {
		const label = String(item.group || "").trim() || resolveGroupLabel(item.name);
		const currentItems = grouped.get(label) || [];
		currentItems.push(item);
		grouped.set(label, currentItems);
	});

	const extraLabels = Array.from(grouped.keys()).filter(
		(label) => !EMAIL_KEYWORD_GROUP_ORDER.includes(label as (typeof EMAIL_KEYWORD_GROUP_ORDER)[number]),
	);

	return [...EMAIL_KEYWORD_GROUP_ORDER, ...extraLabels.sort()].map((label) => ({
		label,
		items: sortGroupItems(label, grouped.get(label) || []),
	})).filter((group) => group.items.length > 0);
};
